import { useState } from 'react';
import { DropdownItem } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { RevertToCropTemplateMutation } from '../../mutations';
import ConfirmationModal from '../basics/ConfirmationModal';

// Handles reverting a crop to the original template data.
const RevertToTemplate = ({
  children,
  id,
  refetchQuery,
  loading,
  mutateAndSetState,
}) => {
  const [reverting, setReverting] = useState(false);
  const [mutate] = useMutation(RevertToCropTemplateMutation);

  const revertToTemplate = async () => {
    await mutateAndSetState(() =>
      mutate({
        variables: { id },
        refetchQueries: [{ query: refetchQuery, variables: { id } }],
        awaitRefetchQueries: true,
      }),
    );
    setReverting(false);
  };

  const renderRevertToTemplateItem = () => (
    <DropdownItem onClick={() => setReverting(true)}>
      Revert to Template
    </DropdownItem>
  );
  const renderRevertToTemplateModal = () => (
    <ConfirmationModal
      isOpen={reverting}
      onCancel={() => setReverting(false)}
      // Use Close instead of Cancel to make it clearer that users
      // are not cancelling the revert, but rather closing the modal
      cancelName="Close"
      onConfirm={revertToTemplate}
      title="Revert to Template"
      actionDescriptionSentence="This will undo any edits made to this crop."
      actionName="Revert"
      disabledActionName="Reverting..."
      actionDisabled={loading}
    />
  );

  return children({ renderRevertToTemplateItem, renderRevertToTemplateModal });
};

export default RevertToTemplate;
